
<c-list-card
    :height      = "80"
    :edit        = "false"
    :title-spacer = "false"
    border-width = "pa-2"
    @selected    = "onClick"
>
    <template v-slot:title>
        <div class="v-flex w-100">
            <div class="card-title title-line">
                {{ title }}
            </div>
            <v-spacer />
            <div class="text-right" style="width: 150px">
                {{ mail.customer ? mail.customer.name : '---' }}
            </div>
            <div class="ml-1 mr-n1" style="width: 25px">
                <v-icon v-if="mail.confirmed" size="22" color="success">mdi-check-circle</v-icon>
                <v-icon v-if="!mail.confirmed" size="22" color="error">mdi-checkbox-blank-circle-outline</v-icon>
            </div>
        </div>
    </template>
    <template v-slot:body>
        <div class="card-subtitle v-flex">
            <div class="subject-line">
                {{ mail.subject }}
            </div>
        </div>
    </template>
</c-list-card>
